<script lang="ts" setup>
import type { MagentoConfigurableProduct, MagentoConfigurableProductOption, MagentoConfigurableProductOptionsValue } from '~layers/app/types/magento'

export interface Props {
  product: MagentoConfigurableProduct
  attribute: MagentoConfigurableProductOption
  selectedOptions?: Record<string, MagentoConfigurableProductOptionsValue>
  parentType?: string
  variantIndex: number
}
const props = defineProps<Props>()

const emit = defineEmits<{
  selected: Record<string, MagentoConfigurableProductOptionsValue | null>
}>()

const { $t } = useI18n()

const selected = (option: MagentoConfigurableProductOptionsValue) => {
  emit('selected', { [props.attribute.attribute_code]: option }, option)
  sizesOpen.value = !sizesOpen.value
}

const clear = () => {
  emit('selected', { [props.attribute.attribute_code]: null })
  sizesOpen.value = !sizesOpen.value
}

const unselectLabel = computed<string>(() => {
  const selectedOption = props.selectedOptions?.[props.attribute.attribute_code] || null
  if (selectedOption) {
    return $t('Unselect')
  }
  return $t('Choose your option')
})

// interaction
const sizesOpen = ref(false)
const options = ref(null)

onClickOutside(options, () => {
  sizesOpen.value = false
})
</script>

<template>
  <div class="configurable__container">
    <div class="configurable__header">
      <div class="configurable__title">
        <span
          v-text="`${attribute.label}: `"
        />
      </div>
    </div>
    <div
      ref="options"
      class="configurable__options"
    >
      <ul class="configurable__list">
        <li v-if="parentType === 'GroupedProduct'">
          <input
            :id="product.id + '_clear'"
            class="configurable__input"
            type="radio"
            :name="product.id + '_' + attribute.attribute_code"
            value=""
            @click="clear"
          >
          <label
            :for="product.id + '_clear'"
            class="configurable__label configurable__unselect"
          >
            <span
              class="configurable__value"
              v-text="unselectLabel"
            />
          </label>
        </li>
        <ProductConfigurableAttributeOption
          v-for="option in attribute.values"
          :key="`${product.id}_${attribute.attribute_code}_${option.value_index}`"
          :product="product"
          :attribute="attribute"
          :option="option"
          :selected-options="selectedOptions"
          :variant-index="variantIndex"
          class="configurable__item"
          @selected="selected"
        />
      </ul>
    </div>
  </div>
</template>

<style>
@import url("~layers/app/components/Product/ConfigurableAttribute.css");
</style>
